export function updateLockedAccountInfo(error) {
    return {
        type: "UPDATE_LOCKED_ACCOUNT_INFO",
        error: error
    };
}
